import { apiSlice } from '../../api/apiSlice';

export const questionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    setQuestionPoint: builder.mutation({
      query: (options) => ({
        url: `Question/${options.questionId}/assignment/${options.assignmentId}/questionPoint?maxPoint=${options.maxPoint}`,
        method: 'POST',
        credentials: 'include'
      })
    }),
    getQuestionHint: builder.mutation({
      query: (options) => ({
        url: `Question/${options.id}/Hint?languageId=${options.languageId}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getQuestionReason: builder.mutation({
      query: (options) => ({
        url: `Question/${options.id}/Reason?languageId=${options.languageId}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getQuestionSampleAnswer: builder.mutation({
      query: (options) => ({
        url: `Question/${options.id}/SampleAnswer?languageId=${options.languageId}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getQuestionMCAnswer: builder.mutation({
      query: (options) => ({
        url: `Question/${options.id}/MCAnswer?languageId=${options.languageId}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getQuestionText: builder.mutation({
      query: (options) => ({
        url: `Question/${options.id}/QuestionText?languageId=${options.languageId}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getQuestionFiles: builder.mutation({
      query: (options) => ({
        url: `Question/${options.id}/QuestionFiles?languageId=${options.languageId}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    })
  })
});

export const {
  useSetQuestionPointMutation,
  useGetQuestionHintMutation,
  useGetQuestionReasonMutation,
  useGetQuestionSampleAnswerMutation,
  useGetQuestionMCAnswerMutation,
  useGetQuestionTextMutation,
  useGetQuestionFilesMutation
} = questionApi;